import React, {useState} from 'react';
import styled from 'styled-components';
import {Button, EMPHASIS} from '@forecast-it/design-system';
import {RecipientField} from './RecipientField';

interface Props {
	to: string[];
	cc: string[];
	bcc: string[];
	onToChange: (values: string[]) => void;
	onCcChange: (values: string[]) => void;
	onBccChange: (values: string[]) => void;
}

const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

const ToRow = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 8px;
`;

const ToField = styled.div`
	flex: 1 1 0%;
`;

const ToggleGroup = styled.div`
	display: flex;
	flex-shrink: 0;
	gap: 4px;
	padding-top: 6px;
`;

export function RecipientsBar({to, cc, bcc, onToChange, onCcChange, onBccChange}: Props) {
	const [showCc, setShowCc] = useState(cc.length > 0);
	const [showBcc, setShowBcc] = useState(bcc.length > 0);

	return (
		<Column>
			<ToRow>
				<ToField>
					<RecipientField label="To" values={to} onChange={onToChange} />
				</ToField>
				<ToggleGroup>
					{!showCc && (
						<Button emphasis={EMPHASIS.LOW} onPress={() => setShowCc(true)}>
							Cc
						</Button>
					)}
					{!showBcc && (
						<Button emphasis={EMPHASIS.LOW} onPress={() => setShowBcc(true)}>
							Bcc
						</Button>
					)}
				</ToggleGroup>
			</ToRow>
			{showCc && <RecipientField label="Cc" values={cc} onChange={onCcChange} />}
			{showBcc && <RecipientField label="Bcc" values={bcc} onChange={onBccChange} />}
		</Column>
	);
}
